import script from "./GoodsItemVday.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoodsItemVday.vue?vue&type=script&lang=ts&setup=true"

import "./GoodsItemVday.vue?vue&type=style&index=0&id=b174c5d0&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b174c5d0"]])

export default __exports__